<template>
  <ValidationProvider
    v-slot="{ errors }"
    class="upload-image-list"
    :rules="rules"
  >
    <input
      type="hidden"
      :value="images"
    >
    <div class="upload-image-list_title-wrap">
      <p class="upload-image-list_title">
        {{ $t(title) }}<span
          v-if="required"
          class="red"
        >*</span>
      </p>
      <UploadImageButton
        v-model="images"
        text
        :factory="factory"
        :upload-url="uploadUrl"
        multiple
      />
    </div>
    <div
      v-if="images.length > 0"
      class="upload-image-list_content"
    >
      <ImagePreviewButton
        v-for="(imageItem,imageIndex) in images"
        :key="imageIndex"
        :small="small"
        :percent="imageItem.percent"
        :medium="medium"
        cancel
        :isloading="imageItem.isloading"
        :text-label="imageItem.url"
        :preview-url="imageItem.previewUrl"
        @click="$_deleteImage(imageIndex)"
      />
    </div>
    <div
      v-if="errors.length > 0"
      class="invalid-text"
    >
      <i class="icon-warning invalid-icon" />
      <p
        v-for="(text_e,text_k) in errors"
        :key="text_k"
        class="text"
      >
        {{ $t(text_e) }}
      </p>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "UploadImageList",
  components: {
    ValidationProvider,
  },
  props: {
    uploadUrl: {
      type: String,
      default: "",
    },
    factory: {
      type: String,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    images: [],
  }),
  watch: {
    images() {
      this.$emit("input", this.images);
    },
    value() {
      this.images = this.value;
    },
  },
  mounted() {
    this.images = this.value;
  },
  methods: {
    $_deleteImage(index) {
      this.images.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/upload-image-list";
</style>